import type {HexColors} from '@/email-maker/grapesjs-email-editor-plugin/src/email-maker.types';

export interface ColorPaletteInfo {
  colors: HexColors;
  id?: number | string;
  type?: ColorPaletteType;
  name?: string;
  tags?: ColorPaletteTag[];
}

export interface UserColorPaletteInfo {
  id: number;
  name: string;
  idUser: number;
  colors: HexColors;
  customizedFromId: string;
  customizedFromType: ColorPaletteCustomizedFromType;
}

enum ColorPaletteCustomizedFromType {
  Admin = 1,
  BrandKit = 2,
}

export interface ColorPaletteInfoToStore {
  colors: string[];
  customizedFromId?: string | number;
  customizedFromType?: ColorPaletteType;
  id?: number;
  name?: string;
}

export enum ColorPaletteType {
  Admin = 1,
  BrandKit = 2,
  User = 3,
}

export interface ColorPalettePill {
  id: number;
  name: string;
  tags: ColorPaletteTag[];
}

interface ColorPaletteTag {
  id: number;
  name: string;
}

export interface AutoBrandingSeenServerResponse {
  hasSeen: number;
}

export interface BrandKitUpdateServerResponse {
  updateSuccess: boolean;
}

export interface ApplyColorPaletteToEmailServerResponse {
  html: string;
  colors: string[];
  suggested?: string[][];
}
